import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import 'braft-editor/dist/index.css';
const Root = styled.div `
  p {
    margin: 0;
  }
  p:empty {
    height: 1.5em;
  }

  ol,
  ul {
    padding-left: 20px !important;
  }
  .carsoursel-inner-img {
    max-width: 400px;
  }
  .inner-img {
    max-width: 360px;
  }
`;
const CarouselContent = ({ className, style, desc, }) => {
    // 这里原本是想用react-zmage,让图片可点击放大缩小，但是图片展示大小没法控制，这里改为加class的普通img
    const replaceImg = () => {
        const imgWrapperList = Array.from(document.querySelectorAll('.image-wrap')).filter(item => item.tagName.toLowerCase() === 'div');
        imgWrapperList.forEach(item => {
            if (item.firstChild && item.firstChild.src) {
                const src = item.firstChild.src;
                ReactDOM.render(React.createElement('img', {
                    src,
                    class: 'inner-img',
                }), item);
            }
        });
    };
    useEffect(() => {
        if (desc) {
            replaceImg();
        }
    }, [desc]);
    if (!desc)
        return null;
    return (<Root className="braft-output-content" style={style} dangerouslySetInnerHTML={{ __html: desc }}/>);
};
export default CarouselContent;
